import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { type GetProductListRequestDto } from "../../dtos/get-product-list-request-dto";
import type { GetProductListResponseDto } from "../../dtos/get-product-list-response-dto";
import { ProductQueryKeys } from "../../generators/product-query-keys";
import { ProductService } from "../../services/product-service";

type UseGetProductDraftListQueryProps = {
  queryParams: GetProductListRequestDto;
  options?: Omit<UseQueryOptions<GetProductListResponseDto>, "queryKey">;
};

export const useGetProductDraftListQuery = ({
  queryParams,
  options
}: UseGetProductDraftListQueryProps) => {
  return useQuery({
    queryKey: ProductQueryKeys.getProductDraftList({ ...queryParams }).queryKey,
    queryFn: async () =>
      await ProductService.getProductDraftList({ payload: queryParams }),
    ...options
  });
};
